import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FooterAbout.module.css';

export default function FooterAbout() {
  const { t } = useTranslation('footer');
  return (
    <div className={styles.root}>
      <div className={styles.title}>{t('ABOUT')}</div>
      <p className={styles.text}>
        {t('ABOUT_DESC_1')}
        <strong>{' ' + t('ABOUT_DESC_2')}</strong>
        {t('ABOUT_DESC_3')}
      </p>
    </div>
  );
}
